<template>
    <b-container>
        <b-row v-if="client && client.Status === 'active'">
            <b-col class="mt-4">
                <b-alert show variant="info">
                    <div>Client: {{ client.Client }}</div>
                    <div>Source: {{ client.Source }}</div>
                </b-alert>
                <div ref="client">
                    <b-alert show variant="dark">
                        <b-button variant="link" @click="copyTextToClipboard()">{{ $t("action.copy") }}</b-button>
                        <div class="mt-2">
                            <strong>Endpoint</strong> : {{ client.Endpoint }}
                        </div>
                        <div><strong>method</strong> : POST</div>
                        <div><strong>content-type</strong> : application/json</div>
                        <div class="mt-4">
                            <strong>Object</strong> :
                            <div>{</div>
                            <div class="ml-4">
                                <div>"TOKEN" : "{{ client.Token }}",</div>
                                <div>"NOCIE" : {{ client.NOCIE }},</div>
                                <div>"NODIV" : {{ client.NODIV }},</div>
                                <div>"name" : "",</div>
                                <div>"email" : "",</div>
                                <div v-if="client.Fields.length > 0">
                                    <div v-for="(field, index) in client.Fields" :key="'field-' + index">
                                        "{{ field.trim() }}" : "",
                                    </div>
                                </div>
                                <div v-if="client.OtherFieldsArr && client.OtherFieldsArr.length > 0">
                                    <div v-for="(field, index) in client.OtherFieldsArr" :key="'OtherFields-' + index">
                                        "{{ field.trim() }}" : "",
                                    </div>
                                </div>
                                <div>"message" : ""</div>
                            </div>
                            <div>}</div>
                        </div>
                    </b-alert>
                </div>

            </b-col>
        </b-row>
        <b-row v-else>
            <b-col class="mt-4">
                <b-alert show variant="info" class="mt-4">
                    <p>{{ $t('info.inactiveKey') }}</p>
                </b-alert>
            </b-col>
        </b-row>

        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>
  
<script>
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
    mixins: [globalF],
    props: ['currentKey', 'modalid'],
    data() {
        return {
            error: "",
            client: null,
            spinner: false,
            fields: [],
            otherField1: "",
            otherField2: "",
            otherField3: "",
            otherField4: "",
            otherField5: ""
        };
    },
    mounted() {
        this.getClient();
    },
    methods: {
        getClient() {
            this.spinner = true;
            this.error = "";
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;

            let promise = this.validateToken();
            promise.then(() => {
                axios
                    .post(
                        url,
                        { request: "getClientById", Id: this.currentKey.Id },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.spinner = false;
                        if (response.data) {
                            this.mapData(response.data);
                            this.client = response.data;
                            if (this.client.Fields.length > 0) {
                                this.client.Fields = this.client.Fields.filter((field) => {
                                    return field.trim() !== "others";
                                });
                            }
                            if (this.client.OtherFields) {
                                this.client.OtherFieldsArr = this.client.OtherFields.split(",");
                            }
                        }
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            });
        },
        mapData(client) {
            this.source = client.Source.trim();
            let fields = client.Fields;
            this.fields = fields.map((field) => {
                return field.trim();
            });
            if (client.OtherFields) {
                let otherFields = client.OtherFields.split(",");
                if (otherFields.length > 0) {
                    this.otherField1 = otherFields[0] ? otherFields[0] : "";
                    this.otherField2 = otherFields[1] ? otherFields[1] : "";
                    this.otherField3 = otherFields[2] ? otherFields[2] : "";
                    this.otherField4 = otherFields[3] ? otherFields[3] : "";
                    this.otherField5 = otherFields[4] ? otherFields[4] : "";
                }
            }
        },
        copyTextToClipboard() {
            let client = this.$refs.client;
            let range = document.createRange();
            range.selectNode(client);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
            document.execCommand("copy");
            window.getSelection().removeAllRanges();
        }
    },
};
</script>
  